const resolveDomainDefaultLanguage = () => {
  if (typeof window === 'undefined' || !window.location) {
    return 'he';
  }
  const hostname = String(window.location.hostname || '').toLowerCase();
  return hostname.includes('tripplannerit.com') ? 'en' : 'he';
};

const state = {
  currentLanguage: resolveDomainDefaultLanguage(),
  supportedLanguages: ['he', 'en']
};

// Helper function to set document direction based on language
const setDocumentDirection = (language) => {
  if (typeof document !== 'undefined') {
    const isHebrew = language === 'he' || language === 'hebrew';
    const direction = isHebrew ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', direction);
    document.documentElement.setAttribute('lang', isHebrew ? 'he' : 'en');
    // Also set on body for compatibility
    if (document.body) {
      document.body.setAttribute('dir', direction);
    }
  }
};

const getters = {
  getCurrentLanguage: (state) => state.currentLanguage,
  getSupportedLanguages: (state) => state.supportedLanguages,
  isHebrew: (state) => state.currentLanguage === 'he',
  isEnglish: (state) => state.currentLanguage === 'en'
};

const mutations = {
  SET_LANGUAGE(state, language) {
    // Normalize language value
    let normalizedLanguage = language;
    if (language === 'hebrew') {
      normalizedLanguage = 'he';
    } else if (language === 'english') {
      normalizedLanguage = 'en';
    }
    
    if (state.supportedLanguages.includes(normalizedLanguage)) {
      state.currentLanguage = normalizedLanguage;
      // Set document direction based on language
      setDocumentDirection(normalizedLanguage);
      // Save to localStorage for persistence with error handling
      try {
        localStorage.setItem('selectedLanguage', normalizedLanguage);
      } catch (error) {
        console.warn('Failed to save language to localStorage:', error);
      }
    }
  },
  LOAD_LANGUAGE_FROM_STORAGE(state) {
    const domainLang = resolveDomainDefaultLanguage();
    try {
      // Force domain language if it's 'en' (tripplannerit.com), ignoring localStorage
      if (domainLang === 'en') {
        state.currentLanguage = 'en';
        setDocumentDirection('en');
        return;
      }
      // For other domains, use localStorage if available, otherwise domain default
      const savedLanguage = localStorage.getItem('selectedLanguage');
      if (savedLanguage && state.supportedLanguages.includes(savedLanguage)) {
        state.currentLanguage = savedLanguage;
        // Set document direction based on loaded language
        setDocumentDirection(savedLanguage);
      } else {
        // Apply domain-based default language for first-time visitors.
        state.currentLanguage = domainLang;
        setDocumentDirection(state.currentLanguage);
      }
    } catch (error) {
      console.warn('Failed to load language from localStorage:', error);
      state.currentLanguage = domainLang;
      setDocumentDirection(domainLang);
    }
  }
};

const actions = {
  setLanguage({ commit }, language) {
    // Normalize language value (handle both 'hebrew'/'english' and 'he'/'en')
    let normalizedLanguage = language;
    if (language === 'hebrew') {
      normalizedLanguage = 'he';
    } else if (language === 'english') {
      normalizedLanguage = 'en';
    }
    commit('SET_LANGUAGE', normalizedLanguage);
  },
  toggleLanguage({ commit, state }) {
    const newLanguage = state.currentLanguage === 'he' ? 'en' : 'he';
    commit('SET_LANGUAGE', newLanguage);
  },
  loadLanguageFromStorage({ commit }) {
    commit('LOAD_LANGUAGE_FROM_STORAGE');
  },
  // Action to set language from ride data
  setLanguageFromRide({ dispatch }, rideLanguage) {
    if (rideLanguage) {
      // Normalize ride language to match our supported languages
      let normalizedLanguage = rideLanguage.toLowerCase();
      if (normalizedLanguage === 'hebrew' || normalizedLanguage === 'he') {
        normalizedLanguage = 'he';
      } else {
        // For any other language (english, en, etc.), use English
        normalizedLanguage = 'en';
      }
      dispatch('setLanguage', normalizedLanguage);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}; 